import { classnames } from '@/helpers';
import { _t } from '@/locale';

import { Fab } from '@/components/elements/forms/buttons';
import Icon from '@/components/icons/Icon';

type Props = {
  title?: string;
  titleComponent?: React.ReactNode;
  onClose?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onBack?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  position?: 'fixed' | 'static' | 'sticky';
  withShadow?: boolean;
  className?: string;
  variant?: 'primary' | 'secondary';
};

export const ModalHeader = ({
  title,
  titleComponent,
  onClose,
  onBack,
  position = 'fixed',
  withShadow = true,
  className,
  variant = 'primary',
}: Props) => {
  const getTitle = () => {
    if (title) {
      return (
        <div className="relative flex min-h-[48px] w-full items-center justify-center md:min-h-[64px]">
          {onBack ? (
            <div className="absolute left-2">
              <Fab icon={<Icon variant="back" />} onClick={onBack} size="md" aria-label={'Back'} />
            </div>
          ) : null}
          <h3
            className={classnames('text-sm md:text-lg', {
              'text-white': variant === 'primary',
              'text-black': variant === 'secondary',
            })}>
            {title}
          </h3>
          {onClose && (
            <div className="absolute right-2">
              <Fab icon={<Icon variant="close" />} onClick={onClose} size="md" aria-label={_t('Close')} />
            </div>
          )}
        </div>
      );
    }

    if (titleComponent) {
      return (
        <div className="relative flex min-h-[48px] w-full items-center justify-between md:min-h-[64px]">
          {titleComponent}
          {onClose ? (
            <div>
              <Fab icon={<Icon variant="close" />} onClick={onClose} size="md" aria-label={_t('Close')} />
            </div>
          ) : (
            <span />
          )}
        </div>
      );
    }

    return null;
  };

  return (
    <header
      className={classnames(
        'top-0 flex w-full',
        {
          relative: position === 'static',
          'z-9999 fixed': position === 'fixed',
          'z-9999 sticky': position === 'sticky',
          'shadow sm:shadow-none': withShadow,
          'bg-primary-700': variant === 'primary',
          'bg-white': variant === 'secondary',
        },
        className,
      )}>
      {getTitle()}
    </header>
  );
};

export default ModalHeader;
